import { Outlet } from 'react-router-dom';
import { ProfileNavItem, SidebarBrand, SidebarUser } from './Sidebar';

export function SelfServiceLayout() {
  return (
    <div className="app">
      <aside className="sidebar">
        <SidebarBrand />
        <nav className="sidebar-nav">
          <ProfileNavItem />
        </nav>
        <SidebarUser />
      </aside>
      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}
